const SuccessCard = () => {
  return (
    <div className="portal">
      <div className="card card-success">
        <div className="check">✓</div>
        <h2>Verbunden!</h2>
        <p className="dim">Du wirst weitergeleitet…</p>
      </div>
    </div>
  );
};

export default SuccessCard;
